import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, useAuthState } from "../hooks/useAuth";
import { profileAPI } from "../services/api";
import "./PlanIntroModal.css";

const THREE_DAYS_MS = 3 * 24 * 60 * 60 * 1000;

const PlanIntroModal = () => {
  const navigate = useNavigate();
  const { user } = useAuthState();
  const { updateUser } = useAuth();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (
      !user ||
      user.hasSeenPlanIntro ||
      user.role !== "user" ||
      user.isActive === false
    ) return;

    const accountAge = Date.now() - new Date(user.createdAt).getTime();
    if (accountAge < THREE_DAYS_MS) return;

    const timer = setTimeout(() => setVisible(true), 30000);
    return () => clearTimeout(timer);
  }, [user]);

  if (!visible) return null;

  const dismiss = async () => {
    setVisible(false);
    try {
      await profileAPI.dismissPlanIntro();
      updateUser({ hasSeenPlanIntro: true });
    } catch {
      updateUser({ hasSeenPlanIntro: true });
    }
  };

  return (
    <div className="plan-intro-overlay" onClick={dismiss}>
      <div className="plan-intro-modal" onClick={(e) => e.stopPropagation()}>
        <p className="plan-intro-text">You're on the Free plan.</p>
        <div className="plan-intro-actions">
          <button
            className="plan-intro-btn plan-intro-btn-primary"
            onClick={async () => {
              await dismiss();
              navigate("/plans");
            }}
          >
            Explore Early Access
          </button>
          <button
            className="plan-intro-btn plan-intro-btn-secondary"
            onClick={dismiss}
          >
            Continue
          </button>
          <p className="plan-intro-hint">You can upgrade anytime from Profile or Plans page</p>
        </div>
      </div>
    </div>
  );
};

export default PlanIntroModal;
